/**
 * Convert data array to CSV format
 * @param {Array} data - The data to convert
 * @returns {string} CSV formatted string
 */
export function toCSV(data, columns = []) {
  if (!data || !data.length) return "";
  const headers = columns.map((c) => c.label);
  const rows = data.map((row) =>
    columns
      .map((col) => {
        let value = row[col.key];
        if (typeof value === "string") {
          value = value.replace(/"/g, '""');
        }
        return `"${value ?? ""}"`;
      })
      .join(",")
  );
  return [headers.join(","), ...rows].join("\r\n");
}
